/* eslint-disable no-unused-expressions */
import { createSlice } from '@reduxjs/toolkit';
// api
import { getMerchant } from '../../api/auth';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  permit_list: [],
  me: {
    role_group_list_name: [],
  },
  permitMerchantId: null,
};

const slice = createSlice({
  name: 'interview-global',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    setMerchant(state, { payload }) {
      return { ...state, ...payload };
    },
    setPermitMerchantId(state, { payload }) {
      state.permitMerchantId = payload;
    },
    resetInitialState() {
      return initialState;
    },
  },
});

export const { resetInitialState, setPermitMerchantId } = slice.actions;

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function fetchMerchant(parms) {
  return async (dispatch) => {
    try {
      const response = await getMerchant(parms);
      console.log(response);
      dispatch(slice.actions.setMerchant(response));
    } catch (error) {
      console.log(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
